import {
   PipelineItemType,
   PipelineStageTransitionUiStyle,
   PipelineTemplates,
   RecordType
} from '@flowwai-frontend/bps-officer-web/graphql'
import {
   CRMItemTypeEnum,
   PipelineItemTypeEnum,
   PipelineStore
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { convertGqlStageTransitionStyleToPipelineStageTransitionStyle } from '../utils/EnumConversionUtils'

export const convertPipeLineTypeToPipeLineTypeEnum = (
   crmItemType: PipelineItemType
): PipelineItemTypeEnum => {
   switch (crmItemType) {
      case PipelineItemType.Deal:
         return PipelineItemTypeEnum.deal
      case PipelineItemType.Lead:
         return PipelineItemTypeEnum.lead
      case PipelineItemType.CustomObject:
         return PipelineItemTypeEnum.customObject
      case PipelineItemType.Application:
         return PipelineItemTypeEnum.application
      default:
         throw new Error(`Pipeline Type : ${crmItemType} not handled`)
   }
}

export const storePipelineInPipelineStore = (
   pipeline: PipelineTemplates,
   pipelineStore: PipelineStore
): void => {
   const { pipelineId, pipelineItemTemplate } = pipeline
   const hasPipeline = pipelineStore.hasPipeline(pipelineId)
   const pipelineName = hasPipeline
      ? pipelineStore.getPipeline(pipelineId).name
      : ''

   const pipelineDisplayName = hasPipeline
      ? pipelineStore.getPipeline(pipelineId).displayName
      : ''

   pipelineStore.createOrUpdatePipeline({
      pipelineId: pipelineId,
      pipelineItemTemplateId: pipelineItemTemplate.pipelineItemTemplateId,
      name: pipelineName,
      displayName: pipelineDisplayName,
      pipelineItemType: convertPipeLineTypeToPipeLineTypeEnum(
         pipeline.pipelineItemType
      ),
      pipelineIcon: {
         iconId: pipeline.pipelineIconId ?? undefined,
         iconColor: pipeline.color ?? undefined
      },
      stageTransitionView: convertGqlStageTransitionStyleToPipelineStageTransitionStyle(
         pipeline.stageTransitionStyle ??
            PipelineStageTransitionUiStyle.Dropdown
      )
   })
}

export const convertPipelineItemTypeEnumToCRMItemTypeEnum = (
   pipelineItemType: PipelineItemTypeEnum
): CRMItemTypeEnum => {
   switch (pipelineItemType) {
      case PipelineItemTypeEnum.lead:
         return CRMItemTypeEnum.Lead
      case PipelineItemTypeEnum.deal:
         return CRMItemTypeEnum.Deal
      case PipelineItemTypeEnum.contact:
         return CRMItemTypeEnum.Contact
      case PipelineItemTypeEnum.customObject:
         return CRMItemTypeEnum.CustomObject
      case PipelineItemTypeEnum.application:
         return CRMItemTypeEnum.Application
   }
}

export const convertGraphqlPipelineItemTypeToCRMItemTypeEnum = (
   pipelineItemType: PipelineItemType
): CRMItemTypeEnum => {
   switch (pipelineItemType) {
      case PipelineItemType.Lead:
         return CRMItemTypeEnum.Lead
      case PipelineItemType.Deal:
         return CRMItemTypeEnum.Deal
      case PipelineItemType.CustomObject:
         return CRMItemTypeEnum.CustomObject
      case PipelineItemType.Application:
         return CRMItemTypeEnum.Application
   }
}

export const convertPipelineItemTypeToGqlRecordType = (
   pipelineItemType: PipelineItemType
): RecordType => {
   switch (pipelineItemType) {
      case PipelineItemType.Lead:
         return RecordType.Lead
      case PipelineItemType.Deal:
         return RecordType.Deal
      case PipelineItemType.CustomObject:
         return RecordType.CustomObject
      case PipelineItemType.Application:
         return RecordType.Application
   }
}

export const convertGqlRecordTypeToPipelineItemTypeEnum = (
   recordType: RecordType
): PipelineItemTypeEnum => {
   switch (recordType) {
      case RecordType.Lead:
         return PipelineItemTypeEnum.lead
      case RecordType.Deal:
         return PipelineItemTypeEnum.deal
      case RecordType.CustomObject:
         return PipelineItemTypeEnum.customObject
      case RecordType.Application:
         return PipelineItemTypeEnum.application
   }
}

export const convertPipelineItemTypeEnumToGqlPipelineItemType = (
   pipelineType: PipelineItemTypeEnum
): PipelineItemType => {
   switch (pipelineType) {
      case PipelineItemTypeEnum.lead:
         return PipelineItemType.Lead
      case PipelineItemTypeEnum.deal:
         return PipelineItemType.Deal
      case PipelineItemTypeEnum.customObject:
         return PipelineItemType.CustomObject
      case PipelineItemTypeEnum.application:
         return PipelineItemType.Application
      default:
         throw new Error('Invalid Pipeline Item Type')
   }
}
